import { render } from "./GlobalConfirmModal.vue?vue&type=template&id=0981012a"
import script from "./GlobalConfirmModal.vue?vue&type=script&lang=js"
export * from "./GlobalConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__